/**
 * Dispatches custom event.
 * @memberof UI
 * @alias dispatchCustomEvent
 * @param {HTMLElement} element
 * @param {string} name - the event name
 * @param {object | unknown} [detail] - the event data object or value
 * @param {boolean} [bubbles] - enable event bubbling. Enabled by default
 * @param {boolean} [cancelable] - enable preventing default action. Enabled by default
 * @returns {CustomEvent}
 */
const dispatchCustomEvent = (
    element: HTMLElement | EventTarget,
    name: string,
    detail: unknown,
    bubbles: boolean = true,
    cancelable: boolean = true
): CustomEvent => {
    const event = new CustomEvent(name, {
        bubbles: bubbles,
        cancelable: cancelable,
        detail: detail,
    });
    element.dispatchEvent(event);
    return event;
};

/**
 * Dispatches native event.
 * @memberof UI
 * @alias dispatchNativeEvent
 * @param {HTMLElement} element
 * @param {string} name - the event name
 * @param {boolean} [bubbles] - enable event bubbling. Enabled by default
 * @returns {Event}
 */
const dispatchNativeEvent = (
    element: HTMLElement | EventTarget,
    name: string,
    bubbles: boolean = true
): Event => {
    const event = new CustomEvent(name, { bubbles: bubbles });
    element.dispatchEvent(event);
    return event;
};

export { dispatchCustomEvent, dispatchNativeEvent };
